import { useEffect, useState } from 'react';

export function useIconFontReady() {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!('fonts' in document)) return setReady(true);

        // Fast path: no placeholder on normal load
        if (document.fonts.check('16px boxicons')) {
            setReady(true);
            return;
        }

        let mounted = true;

        // Wait only when needed
        document.fonts.load('16px boxicons').then(() => {
            if (mounted) setReady(true);
        });

        // Safety fallback
        const t = setTimeout(() => mounted && setReady(true), 800);

        return () => {
            mounted = false;
            clearTimeout(t);
        };
    }, []);

    return ready;
}
